<template>
  <div>user</div>
</template>
<script type="text/ecmascript-6">

export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="stylus" scoped  ref="stylesheet/stylus">
</style>